import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Player from '@vimeo/player';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Cookies from "js-cookie";
import iFrameResizer from "iframe-resizer/js/iframeResizer";
import Lenis from 'lenis';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
import { Viewer } from '@photo-sphere-viewer/core';
import '@photo-sphere-viewer/core/index.css';

Fancybox.bind("[data-fancybox]", {});

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function preventWidows() {
	const elements = document.querySelectorAll('.body-style p, .body-style li, .quote-content');
	elements.forEach(el => {
		if (el.children.length === 0) {
			const text = el.textContent.trim();
			const updated = text.replace(/\s+([^\s]+)$/, '\u00A0$1');

			el.textContent = updated;
		} else {
			el.innerHTML = el.innerHTML.replace(/(\s)([^\s<]+)\s*$/, '&nbsp;$2');
		}
	});
}
preventWidows();


jQuery(document).ready(function($) {
	var windowWidth = $(window).width();

/* ====================== Panorama ======================  */
	function initPanoramaViewer(viewerElement) {
		viewerElement = $(viewerElement);
		if (viewerElement.data('viewer-initialized')) {
			return;
		}

		var panoURL = viewerElement.attr('pano-url');
		var copyright = viewerElement.attr('copyright');
		var copyrightURL = viewerElement.attr('copyright-url');
		new Viewer({
		    container: viewerElement[0],
		    panorama: panoURL,
		     defaultZoomLvl: 0,
		});
		viewerElement.data('viewer-initialized', true);
	}

	$(".panorama-select").change(function(){
		var selected = $(this).val();
		if(selected.length > 0) {
			var anchor_block = '[panorama-title="'+ selected +'"]';
			$('.viewer').removeClass('visible active');
			$(anchor_block).addClass('visible');
			initPanoramaViewer($(anchor_block));

			$('html,body').animate({
		   		scrollTop: $(this).offset().top - 100
			});
		}
	});

	$('.panorama .viewer.visible').each(function( index ) {
		initPanoramaViewer(this);
	});

	let viewerDeactivated = false;
	let pressTimer;
	let longPressTriggered = false;
	const longPressThreshold = 250;

	function startPress(e) {
		longPressTriggered = false;

		pressTimer = setTimeout(() => {
			longPressTriggered = true;
		}, longPressThreshold);
	}

	function endPress(e) {
		clearTimeout(pressTimer);
		if (!longPressTriggered && (e.target == document.querySelector('.viewer.visible.active') || e.target == document.querySelector('canvas'))) {
			$('.viewer.visible').removeClass('active');
			viewerDeactivated = true;
		}
	}
	$(document).on("click", ".panorama .viewer.visible", function (e) {
		if (viewerDeactivated) {
	        viewerDeactivated = false;
	        return;
	    }

		$(this).addClass('active');
	});

	$(document).on("mousedown touchstart", startPress);
	$(document).on("mouseup mouseleave touchend touchcancel", endPress);


/* ====================== INIT LENIS SMOOTH SCROLL ======================  */
	const lenis = new Lenis({
		prevent: (node) => node.matches('header nav.open'),
	});
	lenis.on('scroll', ScrollTrigger.update);
	gsap.ticker.add((time) => {
	  lenis.raf(time * 1000);
	});
	gsap.ticker.lagSmoothing(0);
	window.lenis = lenis;

/* ====================== LENIS ANCHOR SCROLLING ======================  */
	const anchorOffset = -30;

	$(document).on('click', 'a[href*="#"]', function(e) {
		const url = new URL(this.href, location.href);
		if (url.pathname !== location.pathname || !url.hash || url.hash === '#') return;

		const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
		if (!target) return;

		e.preventDefault();
		lenis.scrollTo(target, { offset: anchorOffset });
		history.pushState(null, '', url.hash);
	});

	$(window).on('load', function() {
		if (!location.hash) return;

		const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
		if (target) {
			lenis.scrollTo(target, { offset: anchorOffset });
		}
	});

/* ====================== iFrame Resize ======================  */
	const iframes = iFrameResizer({
		waitForLoad: true,
		onResized: function() {
			ScrollTrigger.refresh();
		}
	}, 'iframe');

/* ====================== iPhone 100vh Workaround ======================  */
	if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && window.innerHeight > window.innerWidth) {
	  let vh = window.innerHeight * 0.01;
	  document.documentElement.style.setProperty('--vh', vh+'px');
	  document.documentElement.style.setProperty('--staticvh', vh+"px");
	  window.addEventListener('resize', function() {
	    let vh = window.innerHeight * 0.01;
	    document.documentElement.style.setProperty('--vh', vh+'px');
	  });
	}

	$('.news-card').on("click", function() {
		var link = $(this).find('.text-link').attr('href');
		window.location.href = link;
	});

//========== Simple Page loader ==========//
    $('.page-loader').addClass('page-loader--hidden');
    $('.page-loader').removeClass('page-loader--change');

    function page_change() {
     var windowWidth = $(window).width()

        if(windowWidth > 992) {
         $('a').not('.video-popup-trigger, .button, .cd-upload-btn, .lightbox-image, .social-share-link, a[href*="#"], .fancybox-link, a[href^="mailto:"], a[href^="tel:"], .remodal-close, .social-share__link, a[target="_blank"], a[data-remodal-target="resource-modal"], .download-link, .newsletter-link, .research-download, .ab-item, .close, .text-link').click(function(e) {
           e.preventDefault();
           $('.page-loader').addClass('page-loader--change');
           setTimeout(function(url) { window.location = url }, 250, this.href);
         });
        }
    }

    page_change();

	window.addEventListener("pageshow", function(evt){
	        if(evt.persisted){
	        setTimeout(function(){
	            window.location.reload();
	        },10);
	    }
	}, false);

/* ====================== Semi Sticky Nav ======================  */
	var prevScrollpos = window.pageYOffset;
	var currentScrollPos = window.pageYOffset;

	if(currentScrollPos > 120) {
		$("header").addClass("headerscrolled");
	}

	document.addEventListener('scroll', function (event) {
		// Listener is in capture mode, so it also hears inner scrollers (e.g. the showcase tab bar) — only react to the page itself
		if (event.target !== document) return;

		var currentScrollPos = window.pageYOffset;

		// Lenis can fire scroll events without the position changing — leave the header as it is
		if (currentScrollPos === prevScrollpos) return;

		if ((prevScrollpos > currentScrollPos)) {
			$('header:not(.no-reveal)').addClass('show');
			$('.anchor-navigation').addClass('append-to-header');
		} else {
			$('header').removeClass('show');
			$('.anchor-navigation').removeClass('append-to-header');
		}

		if(currentScrollPos > 120) {
			$("header:not(.no-reveal)").addClass("headerscrolled");
		} else {
			$("header").removeClass("headerscrolled show");
			$('.anchor-navigation').removeClass('append-to-header');
		}

		prevScrollpos = currentScrollPos;
	}, true);

/* ====================== Cookiebot ======================  */
	$('.update-cookie-consent').on("click", function(e) {
		e.preventDefault();
		Cookiebot.renew();
	});

/* ====================== MOBILE NAV ======================  */
    $('.menu-toggle').on("click", function() {
        $(this).toggleClass('active');
        $('header nav').toggleClass('open');
        $('header').toggleClass('open');
        $('.page-container').toggleClass('menu-open');
        $('body').toggleClass('noscroll');

        if($(this).hasClass('active')) {
        	lenis.stop();
        } else {
        	lenis.start();
        }
    })



/* ====================== Gravity Form - Amend Date Picker ======================  */
$(document).on('gform_post_render', function() {
	if (typeof gform !== 'undefined') {
		gform.addFilter('gform_datepicker_options_pre_init', function (optionsObj, formId, fieldId) {
		optionsObj.firstDay = 1;
		optionsObj.beforeShowDay = function (date) {
			var day = date.getDay();
			var today = new Date();
			today.setHours(0, 0, 0, 0);
			return [date >= today, ''];
		};
		return optionsObj;
		});
	}
	});

/* ====================== Updating Form IDs ======================  */
	$('.gfield.appointment_id input').attr('id', 'appointment_id');
	$('.gfield.preferred_datetime input').attr('id', 'preferred_datetime');

	// On Forms that don't redirect - hide disclaimer
	$(document).on("gform_confirmation_loaded", function (e, form_id) {
		$('.form-disclaimer').hide();
		ScrollTrigger.refresh();
	});

/* ====================== Accordion ======================  */
	//$('.accordion .accordion-row:first-of-type .accordion-row-intro').addClass('active');
	//$('.accordion .accordion-row:first-of-type .accordion-row-content').slideDown();
	//$('.accordion .accordion-row:first-of-type .accordion-row-content').addClass('active');

	if ($('.accordion').length > 0) {
		var urlParam = getParameterByName('accordion-row');
		var accordionRow = $('.accordion-rows .row[accordion-row="'+ urlParam +'"]');


		if ($(accordionRow).length > 0) {
			$(accordionRow).find('.accordion-title').addClass('active');
			$(accordionRow).find('.accordion-content').slideDown(250);
			$(accordionRow).find('.accordion-content').addClass('active');

			$('html,body').animate({
				scrollTop: $(accordionRow).offset().top - 60
			});
		}
	}

	$('.accordion .accordion-title').on('click', function () {
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).next('.accordion-content').slideUp(250);
			$(this).next('.accordion-content').removeClass('active');
		} else {
			$('.accordion .accordion-title').removeClass('active');
			$('.accordion-content').slideUp(250);
			$('.accordion-content').removeClass('active');

			$(this).addClass('active');
			$(this).next('.accordion-content').slideDown(250);
			$(this).next('.accordion-content').addClass('active');
		}
    });


/* ====================== Hero - Background Image Carousel ======================  */
	const hero_image_carousel = new Swiper('.hero.image-carousel .swiper', {
       slidesPerView: 1,
       loop: true,
        speed: 1000,
        effect: "fade",
       	fadeEffect: { crossFade: true },
       	watchSlidesProgress: true,
       	autoplay: {
        	delay: 4000,
        	disableOnInteraction: false,
      	},
       	pagination: {
			el: ".hero.image-carousel .swiper-pagination",
			clickable: true,
		},
	});

/* ====================== Hero - Carousel ======================  */
	const hero_carousel = new Swiper('.hero.carousel .swiper', {
       slidesPerView: 1,
       loop: true,
        speed: 1000,
        effect: "fade",
       	fadeEffect: { crossFade: true },
       	watchSlidesProgress: true,
       	autoplay: {
        	delay: 4000,
        	disableOnInteraction: false,
      	},
       	pagination: {
			el: ".hero.carousel .swiper-pagination",
			clickable: true,
		},
	});

/* ====================== Carousel Navigation ======================  */
	const carousel_navigation = new Swiper('.carousel-navigation .swiper', {
       slidesPerView: 1.3,
       loop: true,
       speed: 1000,
       centeredSlides: true,
       spaceBetween: 30,
       watchSlidesProgress: true,
		breakpoints: {
			1024: {
				slidesPerView: 1.5,
				spaceBetween: 60,
			},
			1280: {
				slidesPerView: 1.5,
				spaceBetween: 130,
			},
		},
	});

	$('.carousel-navigation').on( 'click', '.swiper-slide-next', function( e ){
		carousel_navigation.slideNext();
	});

	$('.carousel-navigation').on( 'click', '.swiper-slide-prev', function( e ){
		carousel_navigation.slidePrev();
	});

/* ====================== Content and Image Carousel ======================  */
	const content_and_image_carousel = new Swiper('.content-and-image-carousel .swiper', {
       slidesPerView: 1.2,
       spaceBetween: 30,
       speed: 1000,
       loop: true,
       watchSlidesProgress: true,
       slideToClickedSlide: true,
       	pagination: {
			el: ".content-and-image-carousel .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			767: {
				slidesPerView: 1.05,
			},
			1024: {
				slidesPerView: 1.05,
				spaceBetween: 0,
			},
		},
	});

	// Positioning pagination based on active slide width
	if(windowWidth < 1024) {
		$(window).on('load', function() {
			setTimeout(function(){
	       		var slideWidth = $('.content-and-image-carousel .swiper-slide-active').width()
				$('.content-and-image-carousel .swiper-pagination').css('left', slideWidth);
	        },1000);

		});
	}

	$('.content-and-image-carousel').on( 'click', '.swiper-slide-next', function( e ){
		content_and_image_carousel.slideNext();
	});

	$('.content-and-image-carousel').on( 'click', '.swiper-slide-prev', function( e ){
		content_and_image_carousel.slidePrev();
	});


/* ====================== Generic Media Swiper ======================  */
    $('.media-carousel').each(function(index, element) {
    	var number = $(element).find('.swiper-slide').length;

    	if(number > 1) {
	        const media_carousel = new Swiper(element, {
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
	            slidesPerView: 1,
	            speed: 600,
	            loop: true,
	            watchSlidesProgress: true,
	            spaceBetween: 10,
				pagination: {
					el: ".media-carousel .swiper-pagination",
					clickable: true,
				},
	        });
	    }
    });


/* ====================== Carousel Timeline ======================  */
	document.querySelectorAll('.carousel-timeline .swiper-wrapper').forEach(function(wrapper) {
		const originals = Array.from(wrapper.children);
		while (originals.length > 1 && wrapper.children.length < 5) {
			originals.forEach(function(slide) {
				wrapper.appendChild(slide.cloneNode(true));
			});
		}
	});

	const carousel_timeline = new Swiper('.carousel-timeline .swiper', {
       slidesPerView: 1.3,
       centeredSlides: true,
       loop: true,
       spaceBetween: 30,
       speed: 1000,
       	navigation: {
			nextEl: ".carousel-timeline .swiper-button-next",
			prevEl: ".carousel-timeline .swiper-button-prev",
		},
       	breakpoints: {
			768: {
				slidesPerView: 1.8,
				spaceBetween: 60,
			},
			1280: {
				slidesPerView: 1.8,
				spaceBetween: 130,
			},
		},
	});

/* ====================== Events Carousel ======================  */
	const events_carousel = new Swiper('.events-carousel .swiper', {
		slidesPerView: 1.3,
		loop: false,
		spaceBetween: 30,
		centeredSlides: true,
		navigation: {
			nextEl: ".events-carousel .swiper-button-next",
			prevEl: ".events-carousel .swiper-button-prev",
		},
		pagination: {
			el: ".events-carousel .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 1.8,
				spaceBetween: 30,
			},
			1280: {
				centeredSlides: false,
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1350: {
				centeredSlides: false,
				slidesPerView: 3,
				spaceBetween: 65,
			},
		},
	});

/* ====================== GSAP ANIMATIONS ======================  */
	const parallax_images = gsap.utils.toArray(".image-parallax img");
	parallax_images.forEach((item, index) => {
		const image_height = $(parallax_images).outerHeight();
		const parallax_parent = $(item).parents('.block');
		const parent_height = $(parallax_parent).outerHeight();

		if(windowWidth > 767) {
			var yDuration = Math.floor((Math.random() * 100) + 100);
		} else{
			var yDuration = Math.floor((Math.random() * 50) + 50);
		}

		if($(item).parent().hasClass('landscape-image-container')) {
			yDuration = yDuration * -1;
		}

		gsap.to(item, {
			y: () => yDuration,
			ease: "power1.in",
			scrollTrigger: {
				trigger: parallax_parent,
				scrub: 2,
				duration: 1,
				start: "top 50%",
				markers: false,
				end: () => parent_height + ' 50%',
				invalidateOnRefresh: true
			}
		});
	});

	let animate = gsap.utils.toArray('.animate')
	animate.forEach((item, index) => {
		// Standalone trigger rather than an empty timeline: timeline-backed triggers defer their
		// first refresh, so a later trigger refreshes them in a nested loop, and any `once`
		// trigger already scrolled past (e.g. on reload) kills itself mid-loop and crashes GSAP 3.9.1
		ScrollTrigger.create({
			trigger: item,
			once: true,
			start:"0 75%",
			end: "500",
			markers: false,
			toggleClass: 'animateelement'
		});
	});

	// Update scroll trigger if ajax loads
	if ($('.blog-overview').length > 0) {
		function outputsize() {
			var blogOverview = $('.blog-overview');
		 	blogOverview.value = blogOverview[0].offsetHeight
		 	ScrollTrigger.refresh();
		}
		outputsize();
		var blogOverview = $('.blog-overview');
		new ResizeObserver(outputsize).observe(blogOverview[0])
	}

/* ====================== Embedded Hero Video Resizing/ Cover ======================  */
	function throttle(func, wait, options) {
		var context, args, result;
		var timeout = null;
		var previous = 0;
		if (!options) options = {};
		var later = function() {
			previous = options.leading === false ? 0 : Date.now();
			timeout = null;
			result = func.apply(context, args);
			if (!timeout) context = args = null;
		};
		return function() {
			var now = Date.now();
			if (!previous && options.leading === false) previous = now;
			var remaining = wait - (now - previous);
			context = this;
			args = arguments;
			if (remaining <= 0 || remaining > wait) {
			if (timeout) {
				clearTimeout(timeout);
				timeout = null;
			}
			previous = now;
			result = func.apply(context, args);
			if (!timeout) context = args = null;
			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining);
			}
			return result;
		};
	}

	  // Vimeo JS
	function getVideoDimensions(element) {
		var parentWidth = $(element).outerWidth();
		var parentHeight = $(element).outerHeight();
		var parentRatio = parentWidth / parentHeight;

		var videoWidth;
		var videoHeight;

		var ratio = 16 / 9;

		if (parentRatio >= ratio) {
			// fit to width
			videoWidth = parentWidth;
			videoHeight = parentWidth / ratio;
		} else {
			// fit to height
			videoHeight = parentHeight;
			videoWidth = (parentHeight / 9) * 16;
		}
		return {
			width: videoWidth,
			height: videoHeight
		};
	}

/* ====================== Hero Video Popup ======================  */
	 if ($('.hero iframe').length > 0) {
			$('.hero .background-video').each(function() {
				var heroBGPlayer = this;
				var containerEl = $(heroBGPlayer).parent('.hero').get(0);
				var videoDimensions = getVideoDimensions(heroBGPlayer);

				$(heroBGPlayer).css({
					'height': videoDimensions.height,
					'width': videoDimensions.width,
				});

			$(window).on('resize', throttle(function() {
				videoDimensions = getVideoDimensions(containerEl);
				$(heroBGPlayer).css({
					'height': videoDimensions.height,
					'width': videoDimensions.width,
				});
			}, 250));
		});
	}

	if ($('.hero .popup-player').length > 0) {
		var popupIframe = document.querySelector('.hero .popup-player');
    	var heroBGPlayer = document.querySelector('.hero .background-video');
    	var fullScreenPlayer = new Player(popupIframe);
		var heroBGPlayer = new Player(heroBGPlayer);

		fullScreenPlayer.on('fullscreenchange', function(data) {
		    if(data['fullscreen'] == false) {
		    	 fullScreenPlayer.pause();
		    } else {
		    	heroBGPlayer.play();
		    }
		});

		$('.hero .play-video').on("click", function() {
			heroBGPlayer.pause();
			fullScreenPlayer.setCurrentTime(0);
			fullScreenPlayer.play();

			setTimeout(function(){
	        	fullScreenPlayer.requestFullscreen();
	        },500);
		})
	}


/* ====================== Video Popup ======================  */
	if ($('.video-block').length > 0) {
		var videoBlockVideo = document.querySelector('.video-block .background-video');
		var videoBlockBG = new Player(videoBlockVideo);
		videoBlockBG.play();
	}

	if ($('.video-block iframe').length > 0) {
		$('.video-block .background-video').each(function() {
			var playerEl = this;
			var containerEl = $(playerEl).parent('.video-block').get(0);

			setTimeout(function(){
				var videoDimensions = getVideoDimensions(playerEl);

				$(playerEl).css({
					'height': videoDimensions.height,
					'width': videoDimensions.width,
				});
			}, 250);
		});
	}

    if ($('.video-block .popup-player').length > 0) {
    	var popupIframe = document.querySelector('.video-block .popup-player');
    	var fullScreenPlayer = new Player(popupIframe);

    	var videoBlockBg = document.querySelector('.video-block iframe');
    	var videoBlockBg = new Player(videoBlockBg);

		fullScreenPlayer.on('fullscreenchange', function(data) {
		    if(data['fullscreen'] == false) {
		    	 fullScreenPlayer.pause();
		    }
		});

		$('.video-block .play-icon').on("click", function() {
			videoBlockBg.pause();
			fullScreenPlayer.setCurrentTime(0);
			fullScreenPlayer.play();
			setTimeout(function(){
	       		fullScreenPlayer.requestFullscreen();
	       	}, 100);
		})
	}

/* ====================== Submit Gravity Form ======================  */
     $('.gform_wrapper .gform_button').on('click', function() {
     	$(this).addClass('submitted');
    	//$(this).parents('.gform_wrapper').find('[type=submit]').click();
    });

/* ====================== Select Parent on Checked ======================  */
	$(document).on( 'click', '.gfield.gfield_error input, .gfield.gfield_error textarea', function( e ){
		$(this).parents('.gfield').find('.validation_message').hide();
		$(this).parents('.gfield').removeClass('gfield_error');
	})

	$(document).on( 'change', '.gfield select', function( e ){
		$(this).parents('.gfield').find('.validation_message').hide();
		$(this).parents('.gfield').removeClass('gfield_error');
	});

	$(document).on( 'change', 'input[type=checkbox]', function( e ){
		if($(this).attr('value') == 'Not Sure') {
			$(this).parents('.gfield_checkbox').find('input').not(this).prop('checked', false);
		} else {
			$(this).parents('.gfield_checkbox').find('input[value="Not Sure"]').prop('checked', false);
		}
	});

/* ====================== Horizontal Scrolling ======================  */
	if ($('.horizontal-image-item').length > 0) {
		const sections = gsap.utils.toArray(".horizontal-image-item");
		const images = gsap.utils.toArray(".horizontal-image-item img");

		let maxWidth = 0;

		const getMaxWidth = () => {
			maxWidth = 0;
			sections.forEach((section) => {
				maxWidth += section.offsetWidth;
			});
		};

		getMaxWidth();

		ScrollTrigger.addEventListener("refreshInit", getMaxWidth);
		gsap.to(sections, {
			x: () => `-${maxWidth - window.innerWidth}`,
			ease: "none",
			scrollTrigger: {
				trigger: ".horizontal-scrolling",
				pin: true,
				scrub: 2,
				start: "top top",
				markers: false,
				end: () => `+=${maxWidth}`,
				invalidateOnRefresh: true
			}
		});

		// Create the parallax effect for images within sections
		sections.forEach(section => {
		const image = section.querySelector('.horizontal-image');
		if (image) {
		  gsap.to(image, {
		    x: () => `-${section.offsetWidth * .2}`, // Adjust the factor for desired lag
		    ease: "none",
		    scrollTrigger: {
		      trigger: section,
		      start: "top bottom",
		      end: () => `+=${maxWidth}`,
		      scrub: 2,
		      invalidateOnRefresh: true
		    }
		  });
		}
		});
	}

/* ====================== Sticky CTA ======================  */
	if($('.sticky-cta').length) {
		if( windowWidth < 1024){
			$('footer').addClass('sticky-cta-present')
		}

		window.addEventListener('scroll', () => {
			if(window.scrollY > 300) {
				$('.sticky-cta').addClass('show');
			} else {
				$('.sticky-cta').removeClass('show');
			}
		});
	}

/* ====================== Table Mobile Notice ======================  */
	document.querySelectorAll('table').forEach((table) => {
		var tbody = $(table).find('tbody');

		/* If the width of the table is bigger than the width of the screen add a .table-notice class to it's parent */
		if($(tbody).width() > window.innerWidth) {
			table.parentElement.classList.add('table-notice');
		}

		/* If any of the columns of the first row of the table is empty (except the first column), we assume that this entire column is empty and add a class to each cell in this column */
		table.querySelectorAll('td').forEach((cell, index) => {
			if(index > 0 && cell.innerHTML === '') {
				cell.classList.add('empty');
			}
		});
	});

/* ====================== Enquiry Category Field Population ======================  */
	$(document).on('change', '.enquiry_type select', function(){
	    var enquiry_type = $(this).children('option:selected').text();
	    $('.gfield.enquiry_category').find('input').val(enquiry_type);
	    $('.gfield.enquiry_category').find('input').text(enquiry_type);
	});

/* ====================== PopUp ======================  */
	function close_popup() {
		$('.popup-container').removeClass('active');
		$('body').removeClass('popup-open');
		Cookies.set('popup_closed', 'true', { expires: 7 });
	}

	function click_outside_popup() {
		$(window).on('click',function(event){
			var target = $(event.target).parents('.popup-container');
			var reviewTarget = event.target.parents('.review-modal');
			var spacesTarget = event.target.parents('#spaces-modal');

			if(!$(target).length || !$(reviewTarget).length || !$(spacesTarget).length) {
				close_popup()
			}
		});
	}

	$('.popup-container .btn').on('click', function() {
		Cookies.set('popup_closed', 'true', { expires: 7 });
	});

	$('.popup-container .close').on('click', function() {
		close_popup();
	});

	// If popup exists, pop it up when cookie notice closed
	if($('.popup-container').length) {
		$('.cookie-policy .cookie-close').on('click', function() {
			if(Cookies.get('popup_closed') != 'true') {
				var timeUp = $('.popup-container').attr('time-until-popup');
				timeUp = (timeUp * 1000);

				setTimeout(function(){
					$('body').addClass('.popup-open');
					$('.popup-container').addClass('active');

					click_outside_popup();
				}, timeUp);
			}
		});
	}

	// If popup exists, pop it up as cookies already closed
	if(Cookies.get('popup_closed') != 'true') {
		if($('.popup-container').length) {
			var timeUp = $('.popup-container').attr('time-until-popup');
			timeUp = (timeUp * 1000) + 2000;

			setTimeout(function(){
				$('body').addClass('popup-open');
				$('.popup-container').addClass('active');

				click_outside_popup();
			}, timeUp);
		}
	}

/* ====================== Positioning Image on Dual Carousel ======================  */
	function positionImage(windowWidth) {
    	if(windowWidth > 1439) {
	    	$('.content-and-dual-image-carousel').each(function(index, element) {
	    		if($(this).next('.content-and-dual-image-carousel.images-right').length) {
	    			$(this).addClass('js-align-image');
			    	var position = $(this).next('.content-and-dual-image-carousel.images-right').find('.images').position();
			    	var image = $(this).find('.image-slide:nth-of-type(2)');

			    	$(image).css('left', position['left']);
			    }
	    	});
	    }
	}

	positionImage(windowWidth);
    $(window).resize(function(){
    	windowWidth = $(window).width();
		positionImage(windowWidth);
    });

/* ====================== Anchor Nav ======================  */
	let fix = gsap.utils.toArray('.anchor-navigation')
	fix.forEach((item, index) => {
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				once: false,
				start:"0 0",
				toggleActions:"restart none none reset",
				end: () => document.documentElement.scrollHeight,
				markers: false,
				toggleClass: 'fixed',
			}
		});
	});

	const $menu = $(".anchor-navigation");
	const $menuItems = $(".anchor-navigation .text-link");

	var clickFlag = false;
    $('.anchor-navigation .text-link').on("click", function(e) {
    	e.preventDefault();
    	clickFlag = true;
		$menuItems.removeClass("active");
		$(this).addClass("active");

		setTimeout(
		function() {
			clickFlag = false;
		}, 1000);

    	var selected = $(this).attr('anchor-link');
		var anchor_block = '[id="'+ selected +'"]';
		lenis.scrollTo(anchor_block);
	});

	$(".anchor-navigation-select").change(function(){
		clickFlag = true;

		setTimeout(
		function() {
			clickFlag = false;
		}, 1000);

		var selected = $(this).val();
		if(selected.length > 0) {
			var anchor_block = '[id="'+ selected +'"]';

			lenis.scrollTo(anchor_block, { offset: -60 });
		}
	});

	if($menu) {
		let pageContents = gsap.utils.toArray('.block');
		pageContents.forEach((item, index) => {
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					start: "top 50%",
					end: "bottom 20%",
					toggleActions: "play none none reverse",
					markers: false,
					onEnter: () => {
						if(clickFlag == false) {
							let item_id = item.id;

							if(windowWidth < 1024) {
								$('.anchor-navigation-select option[value="'+ item_id +'"]').prop('selected', true);
							} else {
								$('.anchor-navigation .text-link').removeClass('active');
								$('.anchor-navigation .text-link[anchor-link="'+ item_id +'"]').addClass('active');
							}
						}
					},
					onEnterBack: () => {
						if(clickFlag == false) {
							let item_id = item.id;

							if(windowWidth < 1024) {
								$('.anchor-navigation-select option[value="'+ item_id +'"]').prop('selected', true);
							} else {
								$('.anchor-navigation .text-link').removeClass('active');
								$('.anchor-navigation .text-link[anchor-link="'+ item_id +'"]').addClass('active');
							}
						}
					},
				}
			});
		});
	}

/* ====================== Price Table Mobile Labels ======================  */
	if(windowWidth < 1024) {
		$('.prices-table td:first-of-type').each(function() {
			var text = $(this).html();
			text = text.replace("January", "Jan");
			text = text.replace("February", "Feb");
			text = text.replace("March", "Mar");
			text = text.replace("April", "Apr");
			text = text.replace("July", "Jul");
			text = text.replace("August", "Aug");
			text = text.replace("September", "Sept");
			text = text.replace("October", "Oct");
			text = text.replace("November", "Nov");
			text = text.replace("December", "Dec");
			text = text.replace("Friday", "Fri");
			text = text.replace("Saturday", "Sat");
			$(this).html(text);
		});
	}

/* ====================== Cookiebot Function to disable for pagespeedinsights ======================  */
window.addEventListener("CookiebotOnDialogInit", function() {
    if (Cookiebot.getDomainUrlParam("CookiebotScan") === "true")
      Cookiebot.setOutOfRegion();
  });


/* ====================== Horizontal Timeline ======================  */
const timelineParallaxItems = (windowWidth) => {
		if(windowWidth > 1023) {
			let timelineParallaxItem = gsap.utils.toArray('.timeline-item')
			timelineParallaxItem.forEach((item, index) => {
			const speed = item.getAttribute('data-speed');
			const xPos = -(5 * speed);

			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: '.timeline-container',
					start: 'top 95%',
					end: '100%',
					scrub: true,
					once: false,
					markers: false
				}
			});
			tl.to(item, {
				x: xPos,
				duration:3,
			});
		});
	}
}

	if($('.timeline-element').length) {
		const simpleBar = new SimpleBar($('.timeline-element')[0], { autoHide: false, direction: 'rtl' });
		simpleBar.getScrollElement().addEventListener('scroll', scrollHandler, function() {});

		var scrollPos = 0;
		function scrollHandler (event) {
		const { scrollLeft, scrollHeight, scrollTop, clientHeight } = event.target;

			if(scrollLeft > scrollPos) {
				$('.timeline-image .inner-image').each(function() {
					var dataSpeed = $(this).parents('.timeline-item').attr('data-speed');
					dataSpeed = dataSpeed * scrollPos;
					dataSpeed = dataSpeed * 0.1;
					if(dataSpeed > 100) {
						dataSpeed = 100;
					}
					$(this).css('transform', 'translateX('+ dataSpeed + 'px)');
				});
			} else {
				$('.timeline-image .inner-image').each(function() {
					var dataSpeed = $(this).parents('.timeline-item').attr('data-speed');
					dataSpeed = dataSpeed * scrollPos;
					dataSpeed = dataSpeed * 0.1;
					if(dataSpeed > 100) {
						dataSpeed = 100;
					}
					$(this).css('transform', 'translateX('+ dataSpeed + 'px)');
				});
			}

			scrollPos = scrollLeft;
		}
	}

	/* ====================== DRAG AND SCROLL DIAGRAM ======================  */
	const slider = document.querySelector('.simplebar-content-wrapper');
	let isDown = false;
	let startX;
	let scrollLeft;

	if($(slider).length > 0) {
		slider.addEventListener('mousedown', (e) => {
			isDown = true;
			slider.classList.add('active');
			startX = e.pageX - slider.offsetLeft;
			scrollLeft = slider.scrollLeft;
		});
		slider.addEventListener('mouseleave', () => {
			isDown = false;
			slider.classList.remove('active');
		});
		slider.addEventListener('mouseup', () => {
			isDown = false;
			slider.classList.remove('active');
		});
		slider.addEventListener('mousemove', (e) => {
			if(!isDown) return;
			e.preventDefault();
			const x = e.pageX - slider.offsetLeft;
			const walk = (x - startX) * 1; //scroll-fast
			slider.scrollLeft = scrollLeft - walk;
		});
	}

	if($('.timeline-container').length) {
		timelineParallaxItems(window.innerWidth);

		window.addEventListener('resize', () => {
			timelineParallaxItems(window.innerWidth);
		});
	}


/* ====================== Reviews Carousel ======================  */
	const reviews_carousel = new Swiper('.review-carousel .swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 1000,
		spaceBetween: 63,
		autoplay: {
        	delay: 4000,
        	disableOnInteraction: false,
      	},
		navigation: {
			nextEl: ".review-carousel .swiper-next",
			prevEl: ".review-carousel .swiper-prev",
		},
		pagination: {
			el: ".review-carousel .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 63,
			},
		},
	});

	$('.review-carousel .read-more').on("click", function() {
		lenis.stop();
		$('body, html').addClass('modal-open')
		reviews_carousel.autoplay.pause();
		$('.review-modal').addClass('active');
		var reviewRelated = $(this).attr('review-related');
		$('.review-modal .review').removeClass('active');
		$('.review-modal .review[review-related=' + reviewRelated + ']').addClass('active');
	});

	/* ====================== Review Modal ======================  */
		function closeReviewModal() {
			lenis.start();
			reviews_carousel.autoplay.start();
			$('body, html').removeClass('modal-open')
			$('.review-modal').removeClass('active');
	 	}

	 	var reviewModal = $('.review-modal');
	 	var close = $('.review-modal .close');

	 	if($(reviewModal).length) {
	 		$('.review-modal .close').on("click", function() {
	 			closeReviewModal()
	 		});
		}
		$(window).click(function(e) {
			if (e.target == $('.review-modal')[0]) {
				closeReviewModal()
			}
	});

/* ====================== Tabbed Content Carousel ======================  */
	var tabbedSwiperOptions = {
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		speed: 1000,
		autoplay: {
			delay: 3500,
			disableOnInteraction: false,
		},
		loop: true,
		pagination: {
			el: ".tabbed-content-and-carousel .swiper-pagination",
			clickable: true,
		},
	};

	function initTabbedSwiper($tabImages) {
		if(!$tabImages.length) {
			return;
		}

		var existingSwiper = $tabImages[0].swiper;
		if(existingSwiper) {
			existingSwiper.destroy(true, true);
		}

		new Swiper($tabImages[0], tabbedSwiperOptions);
	}

	if(windowWidth > 1023) {
		$('.tabbed-content-and-carousel .tab:first-of-type').addClass('active');

		$(document).on('click', '.tabbed-content-and-carousel .tab', function() {
			var $block = $(this).closest('.tabbed-content-and-carousel');
			var related = $(this).attr('tab-related');

			$block.find('.tab, .tab-content, .tab-images').removeClass('active');
			$block.find('[tab-related="' + related + '"]').addClass('active');

			initTabbedSwiper($block.find('.images .tab-images[tab-related="' + related + '"]'));
		});

		initTabbedSwiper($('.tabbed-content-and-carousel .images .tab-images.active'));
	} else {
		$(document).on('touchstart', '.tabbed-content-and-carousel .tab', function(e) {
			var activeTab = $(this);
			if($(this).hasClass('active')) {
				$('.mobile-tab-content').slideUp();
				$(this).removeClass('active');
			} else {
				$('.tab').removeClass('active');
				$('.mobile-tab-content').slideUp();
				$(this).next('.mobile-tab-content').slideDown();
				$(this).addClass('active');
			}

			initTabbedSwiper($(this).next('.mobile-tab-content').find('.tab-images'));
			setTimeout(function(){
				$("html").animate({
					scrollTop: $(activeTab).offset().top - 115
				});

				setTimeout(function(){
					headroom.unfreeze();
				}, 600);
			}, 400);
		});
		$('.tabbed-content-and-carousel .mobile-tab-content .tab-images').each(function() {
			initTabbedSwiper($(this));
		});
	}

	$(document).on('click', '.tabbed-content-and-carousel .tab-content a[href*="#"]', function() {
		var activeTab = $('.tab.active');
		var tabTitle =  $(activeTab).find('.space-title').text().trim();
		$('textarea').val("I'm interested in booking the " + tabTitle + ".");
	});

/* ====================== Showcase Tabs ======================  */
	const hero_images = gsap.utils.toArray(".showcase-hero img, .showcase-hero .hero-inner-container");
	hero_images.forEach((item, index) => {
		const image_height = $(hero_images).outerHeight();
		const parallax_parent = $(item).parents('.block');
		const parent_height = $(parallax_parent).outerHeight();

		if(windowWidth > 767) {
			var yDuration = 80;
		} else{
			var yDuration = 80;
		}

		gsap.to(item, {
			y: () => yDuration,
			ease: "power1.in",
			scrollTrigger: {
				trigger: parallax_parent,
				scrub: 1,
				duration: 1,
				start: "top 50%",
				markers: false,
				end: () => parent_height + ' 50%',
				invalidateOnRefresh: true
			}
		});
	});

    if($('.showcase-hero .showcase-tab').length) {
		const $el = $('.showcase-tabs');

		// Each ScrollTrigger refresh (e.g. the mobile address bar resizing the viewport) moves the
		// pinned element out of and back into its spacer, which resets its horizontal scroll to 0
		let tabsScrollLeft = 0;
		$el.on('scroll', function() {
			tabsScrollLeft = this.scrollLeft;
		});

		ScrollTrigger.create({
			trigger: '.showcase-tabs',
			start: 'top top',
			end: '+=99999',
			pin: true,
			pinSpacing: false,
			onEnter: () => $el.addClass('is-stuck'),
			onLeaveBack: () => $el.removeClass('is-stuck'),
			onRefresh: () => $el.scrollLeft(tabsScrollLeft),
		});

		// On mobile .showcase-tabs scrolls horizontally — bring the selected tab to the centre
		function centreShowcaseTab($tab) {
			const container = $el[0];
			const tab = $tab[0];
			if (!container || !tab || container.scrollWidth <= container.clientWidth) return;

			const containerRect = container.getBoundingClientRect();
			const tabRect = tab.getBoundingClientRect();
			const tabCentre = tabRect.left - containerRect.left + container.scrollLeft + tabRect.width / 2;

			container.scrollTo({
				left: tabCentre - container.clientWidth / 2,
				behavior: 'smooth'
			});
		}

	    let noRevealTimer;

	    $('.showcase-hero .showcase-tab, .btn.next-tab-trigger').click(function(e){
	        var relatedTab = $(this).attr('tab-related');
	        // Keep the header hidden until the scroll up to the tabs has fully settled, otherwise the
	        // upward scroll reveals it over the pinned tabs
	        $('header').addClass('no-reveal').removeClass('show');

	        clearTimeout(noRevealTimer);
	        const releaseHeader = () => {
	        	clearTimeout(noRevealTimer);
	        	// Lenis' final native scroll event lands on the frame after onComplete, so wait a beat
	        	noRevealTimer = setTimeout(() => $('header').removeClass('no-reveal'), 150);
	        };
	        // Fallback in case the scroll is interrupted (e.g. user scrolls) and onComplete never fires
	        noRevealTimer = setTimeout(releaseHeader, 2000);

			lenis.scrollTo('.showcase-tabs-container', {
				offset: 1,
				onComplete: releaseHeader
			});

	        $('.showcase-tab').removeClass('active');
	        var $activeTab = $('.showcase-hero .showcase-tab[tab-related="'+ relatedTab +'"]').addClass('active');
	        centreShowcaseTab($activeTab);

	        $('.showcase-tab-container').removeClass('active');
	        var $activeTabContainer = $('.showcase-tab-container[tab-related="'+ relatedTab +'"]').addClass('active');

	        setTimeout(function(){
	        	$activeTabContainer.find('.vertical-timeline .timeline-item .background-video').each(function() {
	        		sizeTimelineBackgroundVideo(this);
	        		ScrollTrigger.update
	        	});
	        }, 250);
	    });
	}

/* ====================== Before/ After ======================  */
	$('.before-and-after .image-container').twentytwenty();

/* ====================== Vertical Timeline Video Functionality ======================  */
	function sizeTimelineBackgroundVideo(playerEl) {
		var videoDimensions = getVideoDimensions(playerEl);

		if (!videoDimensions.width || !videoDimensions.height) {
			return;
		}

		$(playerEl).css({
			'height': videoDimensions.height,
			'width': videoDimensions.width,
		});
	}

	if ($('.vertical-timeline .timeline-item .background-video').length > 0) {
		$('.vertical-timeline .timeline-item').each(function() {
			var $timelineItem = $(this);
			var playerEl = $timelineItem.find('.background-video').get(0);

			if (!playerEl) {
				return;
			}

			var timelineBG = new Player(playerEl);
			timelineBG.play();

			setTimeout(function(){
				sizeTimelineBackgroundVideo(playerEl);
			}, 250);

			var popupIframe = $timelineItem.next('.popup-player').get(0);

			if (!popupIframe) {
				return;
			}

			var fullScreenPlayer = new Player(popupIframe);

			fullScreenPlayer.on('fullscreenchange', function(data) {
			    if(data['fullscreen'] == false) {
			    	 fullScreenPlayer.pause();
			    }
			});

			$timelineItem.find('.play-icon').on("click", function() {
				timelineBG.pause();
				fullScreenPlayer.setCurrentTime(0);
				fullScreenPlayer.play();
				setTimeout(function(){
		       		fullScreenPlayer.requestFullscreen();
		       	}, 100);
			});
		});
	}

/* ====================== Instagram Trigger Button ======================  */
	$('.instagram-trigger-button').each(function() {
		var blockEl = this;
		var $block = $(blockEl);
		var feedReady = false;

		var observer = new MutationObserver(function() {
			if ($block.find('.eapps-instagram-feed-posts-item-link').length > 0) {
				feedReady = true;
				observer.disconnect();
			}
		});

		observer.observe(blockEl, { childList: true, subtree: true });

		setTimeout(function() {
			observer.disconnect();
		}, 15000);

		$block.find('.btn').on('click', function() {
			if (!feedReady) {
				return;
			}

			var linkEl = $block.find('.eapps-instagram-feed-posts-item-link').first().get(0);

			if (linkEl) {
				linkEl.click();
			}
		});
	});

});